import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, map, Observable, throwError } from 'rxjs';
import { LoadingService } from '../../core/service/loading-progress-bar.service';
import { CommonService } from '../../core/service/common.service';
import { SessionStorageService } from '../../core/service/session-storage';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

  private totalRequests = 0;
  constructor(
    public commonService: CommonService,
    private loadingService: LoadingService,
    private sessionStorageService: SessionStorageService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.totalRequests++;
    const token = this.sessionStorageService.getItem('backendToken');
    request = request.clone({
      headers: request.headers
        .set('Accept', 'application/json')
        .set('Authorization', `Bearer ${token}`),
    });
    this.loadingService.setLoading(true);
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (
          !this.commonService.isNullOrEmptyOrUndefined(error?.error?.Message)
        ) {
          return throwError(() => new Error(error?.error?.Message));
        }
        return throwError(() => new Error(error?.message));
      }),
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests === 0) {
          this.loadingService.setLoading(false);
        }
      })
    );
  }
}
